import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Box, Button, TextField, Typography } from "@mui/material";
import { toast } from "react-toastify";
import { ApiCreateStarRatingData, ApiPostBriefJson } from "../../../apiService/Core/Apicall.tsx";

const StarRatingForm: React.FC = () => {
  const initialValues = {
    starRatingDescription: "",
  };


  const handleSubmit = async (values: any, { resetForm }: any) => {
    try {
      const payload = {
        starRatingDesc: values.starRatingDescription,
      };

      const response = await ApiCreateStarRatingData(payload);
      toast.success("Star Rating Description submitted successfully!");
      console.log(response);
      resetForm();
    } catch (error) {
      toast.error("Failed to submit description");
      console.error(error);
    }
  };

  return (
    <Box className='w-100 p-2'>
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
    >
      {({ values, handleChange, handleBlur }) => (
        <Form className="bg-white border-10 p-2 py-3 w-100">
          <Typography className="fs-42 text-center">Add Star Rating Description</Typography>

          <Box flexDirection={{xs:'column',md:"row"}} className="Form-BriefJson">
            <Box flexDirection={{xs:'column',md:"row"}} className="BriefJson-flex">
              <label htmlFor="starRatingDescription" className="BriefJson-Label form-label">
                Star Rating Description:
              </label>
              <Field
                as={TextField}
                id="starRatingDescription"
                name="starRatingDescription"
                variant="outlined"
                size="small"
                value={values.starRatingDescription}
                onChange={handleChange}
                onBlur={handleBlur}
                fullWidth
              />
              <ErrorMessage
                name="starRatingDescription"
                component="div"
                className="error"
              />
            </Box>
          </Box>

          <div className="text-center">
            <Button
              type="submit"
              variant="contained"
              color="primary"
              className="table-row-background add-update-button"
            >
              Submit
            </Button>
          </div>
        </Form>
      )}
    </Formik>
    </Box>
  );
};

export default StarRatingForm;
